import { Loader2 } from "lucide-react";
import { SEVERITY_CLASS } from "@/lib/ui";

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="sticky top-0 z-20 -mx-6 -mt-6 mb-5 px-6 pt-6 pb-4 flex items-start justify-between gap-4 border-b border-slate-800/70 bg-[#0B0E14]/90 backdrop-blur-md" data-testid={testid}>
      <div>
        <h1 className="font-heading font-extrabold text-2xl text-slate-100 tracking-tight">{title}</h1>
        {subtitle && <p className="text-[13px] text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, sub, icon: Icon, tone = "slate", onClick, testid }) {
  const tones = {
    slate: "text-slate-300", cyan: "text-cyan-300", rose: "text-rose-300",
    amber: "text-amber-300", emerald: "text-emerald-300", sky: "text-sky-300",
  };
  return (
    <div data-testid={testid} onClick={onClick}
      className={"card-surface rounded-lg p-4 " + (onClick ? "cursor-pointer hover:bg-slate-800/40 transition-colors" : "")}>
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">{label}</span>
        {Icon && <Icon size={16} className={tones[tone]} />}
      </div>
      <div className={"font-heading font-extrabold text-3xl mt-2 " + tones[tone]}>{value}</div>
      {sub && <div className="text-[11px] text-slate-500 mt-1">{sub}</div>}
    </div>
  );
}

export function SeverityBadge({ severity }) {
  return (
    <span className={"inline-block rounded border px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide " +
      (SEVERITY_CLASS[severity] || SEVERITY_CLASS.LOW)}>{severity}</span>
  );
}

export function Spinner() {
  return <div className="flex items-center justify-center py-20 text-slate-500"><Loader2 className="animate-spin" size={22} /></div>;
}

export function Empty({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {Icon && <Icon size={30} className="text-slate-700 mb-3" />}
      <div className="text-slate-400 font-medium">{title}</div>
      {hint && <div className="text-[13px] text-slate-600 mt-1 max-w-md">{hint}</div>}
    </div>
  );
}

export function Btn({ children, variant = "primary", className = "", ...props }) {
  const variants = {
    primary: "text-slate-950 hover:scale-[1.02]",
    ghost: "text-slate-300 bg-slate-800/70 hover:bg-slate-800 border border-slate-700",
    danger: "text-rose-200 bg-rose-950/60 hover:bg-rose-900/60 border border-rose-800",
  };
  const style = variant === "primary" ? { background: "linear-gradient(135deg,#00F0FF,#38BDF8)" } : {};
  return (
    <button {...props} style={style}
      className={"inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-[13px] font-semibold transition-all disabled:opacity-50 " + variants[variant] + " " + className}>
      {children}
    </button>
  );
}
